import {Component, Material, Mesh, MeshComponent, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {vec3} from 'gl-matrix';

export class CircularSpawner extends Component {
    static TypeName = 'circular-spawner';

    @property.float(50)
    radiusX: number = 50;

    @property.float(10)
    radiusZ: number = 10;

    @property.int(100)
    count: number = 100;

    start() {
        const prefab = this.object.children[0];

        // Get the position of the parent object in world space
        const centerPosition = vec3.create();
        this.object.getPositionWorld(centerPosition);

        for (let i = 0; i < this.count; ++i) {
            // Generate random positions within the rectangular area
            const positionX = centerPosition[0] + (Math.random() * 2 - 1) * this.radiusX;
            const positionZ = centerPosition[2] + (Math.random() * 2 - 1) * this.radiusZ;

            const position = vec3.fromValues(positionX, 0, positionZ);

            const child = prefab.clone();

            child.setPositionWorld(position);

            const angle = Math.random() * 360;
            child.rotateAxisAngleDegObject([0, 1, 0], angle);
            child.setScalingWorld([2, 2, 2]);
        }
    }
}
